import { Field } from 'redux-form';

import { RadioButton } from 'common/components/forms';
import { currencyFormat } from 'common/helpers/numberHelper';

const ShipMethod = (props) => {
  const { shipMethod, settings } = props;

  return (
    <div data-ship-method-code={shipMethod.code}>
      <label className="c7-radio" htmlFor={`c7-${shipMethod.title}`}>
        <Field
          name="shippingServiceId"
          id={`c7-${shipMethod.title}`}
          component={RadioButton}
          label={shipMethod.title}
          type="radio"
          value={shipMethod.id}
          noLabel
        />
        <div>
          {shipMethod.title}
          <span className="c7-radio__action-message">
            {renderActionMessage(shipMethod)}
          </span>
        </div>
        <div className="c7-radio__right">
          {renderPrice(shipMethod, settings)}
        </div>
      </label>
    </div>
  );
};

const renderActionMessage = (shipMethod) => {
  if (
    typeof shipMethod.addToCartPrice !== 'undefined' &&
    shipMethod.addToCartPrice < shipMethod.price &&
    shipMethod.actionMessage
  ) {
    return shipMethod.actionMessage;
  }
  return null;
};

const renderPrice = (shipMethod, settings) => {
  if (
    typeof shipMethod.addToCartPrice !== 'undefined' &&
    shipMethod.addToCartPrice < shipMethod.price
  ) {
    return (
      <>
        <span className="c7-radio__right__promo">
          {currencyFormat(shipMethod.price, settings)}
        </span>
        {currencyFormat(shipMethod.addToCartPrice, settings)}
      </>
    );
  }
  return <>{currencyFormat(shipMethod.price, settings)}</>;
};

export default ShipMethod;
